import { Component, OnInit } from '@angular/core';
import * as echarts from 'echarts';
import { Router } from '@angular/router';
import { AuthService } from "../../services/auth.service";
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { HomeService } from '../../services/home.service';
import { AlertComponent } from '../alert/alert.component';
import { CommonEncrypt } from '../../utils/common.encrypt';
import { StudyBase } from '../common/study-base';
import { empty, interval } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  // 用户名密码
  username: string = 'D0001';
  password: string = '123456';
  bsWorkModalRef: BsModalRef;
  bsModalRef: BsModalRef;
  organList: any = []
  selectedValue: any = '';
  // username:string;
  // password:string;

  constructor(private auth: AuthService,
    public router: Router,
    public service: HomeService,
    public modalService: BsModalService) {
    this.auth.random();
  }


  ngOnInit() {

    // 项目动态滚动
    let timer;
    let speed = 10;
    let box = document.getElementById("box");
    let neirong = document.getElementById("neirong");
    let neirong2 = document.getElementById("neirong2");
    neirong2.innerHTML = neirong.innerHTML;
    function move() {
      if (neirong2.scrollWidth - box.scrollLeft <= 0) {
        box.scrollLeft = 0;
      } else {
        box.scrollLeft++;
      }
    }
    box.onmouseover = function () {
      clearInterval(timer);
    }
    box.onmouseout = function () {
      timer = setInterval(move, speed);
    }
    timer = setInterval(move, speed);
    // 项目动态滚动 end

  }

  getRole(role) {
    this.selectedValue = role
  }
  // 获取用户组织

  checkOrg() {
    this.service.checkOrg(this.username, this.password).subscribe(
      data => {
        console.log(data.resultCode)
        let code = data.resultCode
        let info = data.resultMsg
        if (code == '100000') {
          this.getUserOrgan()
        } else {
          // this.alertItem(info);          
          document.getElementById('error').style.display = 'block';
        }
      }
    )
  }

  getUserOrgan() {
    this.service.getUserOrgan().subscribe(
      data => {
        console.log(data.resultCode)
        let code = data.resultCode
        let info = data.resultInfo
        if (code == '100000') {
          this.organList = info
        } else {
          // this.alertItem(info);          
          document.getElementById('error').style.display = 'block';
        }
      }
    )
  }

  // 登录
  signin() {
    if (this.username.length == 0 || this.password.length == 0 || this.selectedValue.length == 0) {
      console.log(this.username)
      console.log(this.password)
      console.log(this.selectedValue)
      this.alertItem('非法输入，请重新检查信息是否完整')
    } else {
      this.service.signin(this.username, this.password, this.selectedValue).subscribe(
        data => {
          console.log(data.resultCode)
          let code = data.resultCode
          let info = data.resultMsg
          if (code == '100000') {
            this.router.navigate(['home', {
              newLogin: true
            }]);
          } else {
            // this.alertItem(info);          
            document.getElementById('error').style.display = 'block';
          }
        }
      )
    }

  }



  // 弹出
  alertItem(msg) {
    const initialState = {
      title: '系统提示',
      content: msg,
      cancelButtonName: "确定",
      confirmButtonShowFlag: false
    };
    this.bsModalRef = this.modalService.show(AlertComponent, { initialState });

    this.modalService.onHidden.subscribe(() => { });
    this.bsModalRef.content.onClose = (msg: string) => {

    }
  }
}
